import React from 'react';
import { colors } from '../styles/theme';

export default ({ fill = colors.grayscale.stone, height = 10 }) => {
  const ratio = 14 / 10;
  const width = height * ratio;
  return (
    <svg width={width} height={height} viewBox="0 0 14 10" fill="none">
      <path
        d="M13.7353 4.46883L9.25 0.219436C8.94118 -0.0731452 8.44118 -0.0731452 8.14706 0.219436C7.83824 0.512017 7.83824 0.985719 8.14706 1.26437L11.3088 4.25984H0.779412C0.352941 4.25984 0 4.59422 0 4.99826C0 5.4023 0.352941 5.73668 0.779412 5.73668H11.2941L8.14706 8.73215C7.83824 9.02473 7.83824 9.49843 8.14706 9.77708C8.29412 9.91641 8.5 10 8.70588 10C8.91177 10 9.10294 9.93034 9.26471 9.77708L13.7647 5.51376C13.9118 5.37443 14 5.17938 14 4.98433C13.9706 4.8032 13.8824 4.60815 13.7353 4.46883Z"
        fill={fill}
      />
    </svg>
  );
};
